import React from "react";
import { Alert, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useCourseGeneration } from "../contexts/CourseGenerationContext";

const CourseGenerationBanner: React.FC = () => {
  const { visible, status, error, dismiss } = useCourseGeneration();

  // Only surface the banner for a final outcome — success or failure.
  if (!visible || (status !== "completed" && status !== "failed")) return null;

  const isFailed = status === "failed";

  return (
    <Alert
      severity={isFailed ? "error" : "success"}
      variant="filled"
      action={
        <IconButton size="small" color="inherit" onClick={dismiss}>
          <CloseIcon fontSize="small" />
        </IconButton>
      }
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: (t) => t.zIndex.appBar + 1,
        borderRadius: 0,
      }}
    >
      {isFailed
        ? `Course generation failed${error ? `: ${error}` : "."}`
        : "Your course has finished generating."}
    </Alert>
  );
};

export default CourseGenerationBanner;